import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.lootbox.box,
    props.user.user,
    (box, user) => {
        return {
            box,
            user
        }
    }
)